import { QueryApiService } from 'src/common/api-service';
import { AuditableEntity } from '../common';

export interface Methodology extends AuditableEntity<string> {
  name: string;
}

export class MethodologyApiService extends QueryApiService<Methodology> {
  constructor() {
    super('methodologies');
  }
}
